/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const dataSchema = z.object({ resolved: z.literal(true) });

export const resolveChallengeIssueResponseSchema = createApiResponseSchema(
  dataSchema,
) as z.ZodSchema<IAPI<{ resolved: true }>>;

export type IResolveChallengeIssueResponse = IAPI<{ resolved: true }>;
